// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GcpGkeNodePoolTaintEffect } from './GcpGkeNodePoolTaintEffect';
import {
  GcpGkeNodePoolTaintEffectFromJSON,
  GcpGkeNodePoolTaintEffectFromJSONTyped,
  GcpGkeNodePoolTaintEffectToJSON,
  GcpGkeNodePoolTaintEffectToJSONTyped,
} from './GcpGkeNodePoolTaintEffect';

/**
 *
 * @export
 * @interface GcpGkeNodePoolTaint
 */
export interface GcpGkeNodePoolTaint {
  /**
   *
   * @type {GcpGkeNodePoolTaintEffect}
   * @memberof GcpGkeNodePoolTaint
   */
  effect?: GcpGkeNodePoolTaintEffect;
  /**
   *
   * @type {string}
   * @memberof GcpGkeNodePoolTaint
   */
  key?: string;
  /**
   *
   * @type {string}
   * @memberof GcpGkeNodePoolTaint
   */
  value?: string;
}

/**
 * Check if a given object implements the GcpGkeNodePoolTaint interface.
 */
export function instanceOfGcpGkeNodePoolTaint(
  value: object,
): value is GcpGkeNodePoolTaint {
  return true;
}

export function GcpGkeNodePoolTaintFromJSON(json: any): GcpGkeNodePoolTaint {
  return GcpGkeNodePoolTaintFromJSONTyped(json, false);
}

export function GcpGkeNodePoolTaintFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GcpGkeNodePoolTaint {
  if (json == null) {
    return json;
  }
  return {
    effect:
      json['effect'] == null
        ? undefined
        : GcpGkeNodePoolTaintEffectFromJSON(json['effect']),
    key: json['key'] == null ? undefined : json['key'],
    value: json['value'] == null ? undefined : json['value'],
  };
}

export function GcpGkeNodePoolTaintToJSON(json: any): GcpGkeNodePoolTaint {
  return GcpGkeNodePoolTaintToJSONTyped(json, false);
}

export function GcpGkeNodePoolTaintToJSONTyped(
  value?: GcpGkeNodePoolTaint | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    effect: GcpGkeNodePoolTaintEffectToJSON(value['effect']),
    key: value['key'],
    value: value['value'],
  };
}
